import $ from 'jquery';

export default class DynamicInstagram {
  constructor(section) {
    this.$el = $(section.el);
    this.initializedClass = 'instagram-initialized';

    this._validate();
  }

  _validate() {
    this.photoContainer = $('[data-instagram-photos]', this.$el);
    this.onBoarding = $('[data-instagram-photo-onboarding]', this.$el);
    const accessToken = $('[data-instagram-token]', this.$el).attr('data-instagram-token');
    const isInitialized = this.$el.hasClass(this.initializedClass);

    if (this.photoContainer.length) {
      this._getPhotos(accessToken, isInitialized);
    }

    this._toggleOnBoarding();
  }

  _toggleOnBoarding() {
    this.$el.removeClass('module-hidden').removeClass(this.initializedClass);
  }

  _getPhotos(accessToken, isInitialized) {
    if (!accessToken.length) { this._hasError(false); }
    if (isInitialized) { return; }

    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${accessToken}&count=6&callback=`;

    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url,

      success: (response) => {
        if (response.meta.code === 200) {
          const photos = [];
          for (let i = 0; i < response.data.length; i++) {
            const photo = response.data[i];
            const image = photo.images.standard_resolution;
            const scale = image.width > image.height ? 'y' : 'x';
            photos.push(`\
              <div class="instagram-photo">
                  <a
                      class="instagram-link"
                      target="_blank"
                      href="${photo.link}"
                  >
                      <img
                          class="
                              instagram-image
                              instagram-image-scale-${scale}
                          "
                          src="${image.url}"
                      />
                  </a>
              </div>\
            `);
          }

          this.photoContainer.html(photos.join(''));
          this.$el
            .removeClass('module-hidden')
            .addClass(this.initializedClass);
        } else {
          this._hasError(response);
        }
      },

      error: response => this._hasError(response),
    });
  }

  _hasError(response) {
    this.$el
      .addClass('module-hidden')
      .removeClass(this.initializedClass);
    this.photoContainer.html();

    if (response) { console.log(`Instagram error: ${response.meta.error_message}`); }
  }

  update() {
    this._validate();
  }
}
